// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlayCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/PlayCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var PlayCircleTwoTone = function PlayCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleTwoToneSvg
  }));
};

PlayCircleTwoTone.displayName = 'PlayCircleTwoTone';
export default /*#__PURE__*/React.forwardRef(PlayCircleTwoTone);